export const environment = {
  production: false,
  gosuUrl:'https://3028.api.gosu.bar',
  liffId:'1653819764-oM1X1ZV9',
  serverUrl:'https://nissan.gosu.bar/api'
};

